var React = require('react');
import '../public/less/forms.less';
import '../public/less/userDetails.less';
import '../public/less/grid.less';
import { Load } from './common/basic';
import axios from 'axios';
import DataGrid from './common/dataGrid';
import { ApplyAndReset } from './common/forms';
import DatePicker from './common/datepicker';
import UserSearch from './common/userSearch';
import PatientDetails from './patientSummary/PatientDetails';
import PatientMeasurements from './patientSummary/Measurements';
import Plans from './patientSummary/Plans';
import PatientActions from './patientSummary/PatientActions';


module.exports = class PatientSummary extends React.Component {
    constructor(props) {
        super(props);

        this.updateDoctor = this.updateDoctor.bind(this);
    }

    updateDoctor(id) {
        this._plans.updateDoctor(id);
    }

    render() {
        var patientID = this.props.params.userID;
        //<PatientTretments patientID={patientID}/>
        return (
            <div>
                <PatientDetails patientID={patientID} updateDoctor={this.updateDoctor} connectedUserID={this.props.params.user.ID}  />
                <div className='container'>
                    <PatientMeasurements patientID={patientID} />
                    <hr />
                    <Plans patientID={patientID} ref={(plans) => { this._plans = plans; }} connectedUserID={this.props.params.user.ID} />
                    <hr />
                    <PatientActions patientID={patientID} />
                </div>
            </div>
        )
    }
};

function dateFormatter(cell, row) {
    return `${new Date(cell).toLocaleDateString()}`;
}


// WEBPACK FOOTER //
// ./modules/patientSummary.jsx